import { useForm } from '@tanstack/react-form'
import { getRouteApi } from '@tanstack/react-router'
import { useDebounce } from 'commons/hooks/common'
import { FF, TextInput } from 'ui/components'
import { FilterPanel } from 'ui/components/Table'

import { PCTPayload } from '../../../../types/PCT'

import * as SC from './styles'

const routeApi = getRouteApi('/_app/bsa/pct-list')

export const FilterForm = () => {
  const searchParams = routeApi.useSearch()
  const navigate = routeApi.useNavigate()
  const isChanged = routeApi.useLoaderDeps({ select: (s) => s.isChanged })
  const formApi = useForm({
    defaultValues: {
      searchString: searchParams.searchString || ''
    } as Pick<PCTPayload, 'searchString'>
  })

  const updateSearchParams = (newValue: string) =>
    navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, searchString: newValue }), resetScroll: false })

  const throttledSearch = useDebounce(updateSearchParams, 300)

  const clear = () => {
    formApi.reset()
    navigate({ search: undefined })
  }

  return (
    <FilterPanel isDirty={isChanged} onReset={clear}>
      <SC.FormWrapper>
        <SC.Row>
          <formApi.Field
            name="searchString"
            validators={{
              onChange: ({ value }) => {
                throttledSearch(value)
                return undefined
              }
            }}
            children={(field) => (
              <FF
                field={field}
                label="File Name"
                input={(inputProps) => <TextInput {...inputProps} placeholder="Start entering file name" />}
              />
            )}
          />
        </SC.Row>
      </SC.FormWrapper>
    </FilterPanel>
  )
}
